export default [
  {
    path: '/account-management/current-savings-account-list',
    name: 'current-savings-account-list',
    component: () => import('@/views/pages/account-management/customer-account/savings-current/Index.vue'),
    meta: {
      pageTitle: 'Current and Savings Account',
      hasPermission: 'VIEW_SAVING_CURRENT_ACCOUNT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Current and Savings Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/current-savings-account/:type/:id?',
    name: 'current-savings-account',
    component: () => import('@/views/pages/account-management/customer-account/savings-current/SavingsCurrentAccount.vue'),
    meta: {
      pageTitle: 'Current and Savings Account',
      hasPermission: ['MODIFY_SAVING_CURRENT_ACCOUNT', 'CREATE_SAVING_CURRENT_ACCOUNT'],
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Current and Savings Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/current-savings-account-list-nib',
    name: 'current-savings-account-list-nib',
    component: () => import('@/views/pages/account-management/customer-account/savings-current-nib/Index.vue'),
    meta: {
      pageTitle: 'Current and Savings Account',
      hasPermission: 'VIEW_SAVING_CURRENT_ACCOUNT_NIB',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Current and Savings Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/current-savings-account-nib/:type/:id?',
    name: 'current-savings-account-nib',
    component: () => import('@/views/pages/account-management/customer-account/savings-current-nib/SavingsCurrentAccount.vue'),
    meta: {
      pageTitle: 'Current and Savings Account',
      hasPermission: ['MODIFY_SAVING_CURRENT_ACCOUNT_NIB', 'CREATE_SAVING_CURRENT_ACCOUNT_NIB'],
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Current and Savings Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/charge-management',
    name: 'charge-management',
    component: () => import('@/views/pages/account-management/ChargeManagement.vue'),
    meta: {
      pageTitle: 'Charges',
      hasPermission: 'VIEW_CHARGE',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Charges',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/memo-management',
    name: 'memo-management',
    component: () => import('@/views/pages/account-management/customer-account/memo/Index.vue'),
    meta: {
      pageTitle: 'Memo',
      hasPermission: 'VIEW_MEMO',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Memo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/add-memo',
    name: 'add-memo',
    component: () => import('@/views/pages/account-management/customer-account/memo/Memo.vue'),
    meta: {
      pageTitle: 'Memo',
      hasPermission: 'VIEW_MEMO',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Memo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/account-statement',
    name: 'account-statement',
    component: () => import('@/views/pages/account-management/customer-account/AccountStatement.vue'),
    meta: {
      pageTitle: 'Account Statement',
      hasPermission: 'ACCOUNT_STATEMENT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Account Statement',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/overdraft/:type/:id?',
    name: 'overdraft',
    component: () => import('@/views/pages/account-management/customer-account/overdraft/Overdraft.vue'),
    meta: {
      pageTitle: 'Overdraft',
      hasPermission: 'MODIFY_OVERDRAFT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Overdraft',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/overdraft-list',
    name: 'overdraft-list',
    component: () => import('@/views/pages/account-management/customer-account/overdraft/Index.vue'),
    meta: {
      pageTitle: 'Overdraft',
      hasPermission: 'VIEW_OVERDRAFT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Overdraft',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/overdraft-nib/:type/:id?',
    name: 'overdraft-nib',
    component: () => import('@/views/pages/account-management/customer-account/overdraftNIB/Overdraft.vue'),
    meta: {
      pageTitle: 'Overdraft',
      hasPermission: 'MODIFY_OVERDRAFT_NIB',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Overdraft',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/overdraft-list-nib',
    name: 'overdraft-list-nib',
    component: () => import('@/views/pages/account-management/customer-account/overdraftNIB/Index.vue'),
    meta: {
      pageTitle: 'Overdraft',
      hasPermission: 'VIEW_OVERDRAFT_NIB',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Overdraft',
          active: true,
        },
      ],
    },
  },
  // products
  {
    path: '/account-management/fd-product',
    name: 'fd-product',
    component: () => import('@/views/pages/account-management/products/FDProduct.vue'),
    meta: {
      pageTitle: 'FD Product',
      hasPermission: 'VIEW_FIXED_DEPOSIT_PRODUCT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'FD Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fd-product-nib',
    name: 'fd-product-nib',
    component: () => import('@/views/pages/account-management/products/FDProductNIB.vue'),
    meta: {
      pageTitle: 'FD Product',
      hasPermission: 'VIEW_FIXED_DEPOSIT_PRODUCT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'FD Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-product-list',
    name: 'loan-product-list',
    component: () => import('@/views/pages/account-management/products/Loan/Index.vue'),
    meta: {
      pageTitle: 'Loan Product',
      hasPermission: 'VIEW_LOAN_PRODUCT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-product/:type/:id?',
    name: 'loan-product',
    component: () => import('@/views/pages/account-management/products/Loan/LoanProduct.vue'),
    meta: {
      pageTitle: 'Loan Product',
      hasPermission: 'VIEW_LOAN_PRODUCT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-product-list-nib',
    name: 'loan-product-list-nib',
    component: () => import('@/views/pages/account-management/products/LoanNIB/Index.vue'),
    meta: {
      pageTitle: 'Loan Product',
      hasPermission: 'VIEW_LOAN_PRODUCT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-product-nib/:type/:id?',
    name: 'loan-product-nib',
    component: () => import('@/views/pages/account-management/products/LoanNIB/LoanProduct.vue'),
    meta: {
      pageTitle: 'Loan Product',
      hasPermission: 'VIEW_LOAN_PRODUCT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/casa-product/:type/:id?',
    name: 'casa-product',
    component: () => import('@/views/pages/account-management/products/CASAProduct/CASAProduct.vue'),
    meta: {
      pageTitle: 'CASA Product',
      hasPermission: 'MODIFY_SAVING_CURRENT_PRODUCT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'CASA Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/casa-product-list',
    name: 'casa-product-list',
    component: () => import('@/views/pages/account-management/products/CASAProduct/Index.vue'),
    meta: {
      pageTitle: 'CASA Product',
      hasPermission: 'VIEW_SAVING_CURRENT_PRODUCT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'CASA Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/casa-product-nib/:type/:id?',
    name: 'casa-product-nib',
    component: () => import('@/views/pages/account-management/products/CASAProductNIB/CASAProduct.vue'),
    meta: {
      pageTitle: 'CASA Product',
      hasPermission: 'MODIFY_SAVING_CURRENT_PRODUCT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'CASA Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/casa-product-list-nib',
    name: 'casa-product-list-nib',
    component: () => import('@/views/pages/account-management/products/CASAProductNIB/Index.vue'),
    meta: {
      pageTitle: 'CASA Product',
      hasPermission: 'VIEW_SAVING_CURRENT_PRODUCT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'CASA Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/individual-customer-information',
    name: 'individual-customer-information',
    component: () => import('@/views/pages/account-management/customers/individual-customer/Index.vue'),
    meta: {
      pageTitle: 'Individual Customer Information',
      hasPermission: 'VIEW_INDIVIDUAL_CUSTOMER',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Customer Information',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/individual-customer/:type/:id?',
    name: 'individual-customer',
    component: () => import('@/views/pages/account-management/customers/individual-customer/IndividualCustomer.vue'),
    meta: {
      pageTitle: 'Individual Customer',
      hasPermission: ['MODIFY_INDIVIDUAL_CUSTOMER', 'CREATE_INDIVIDUAL_CUSTOMER'],
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Individual Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/group-customer-information',
    name: 'group-customer-information',
    component: () => import('@/views/pages/account-management/customers/group/Index.vue'),
    meta: {
      pageTitle: 'Corporate/Group Information',
      hasPermission: 'VIEW_GROUP_CUSTOMER',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Corporate/Group Information',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/group-customer/:type/:id?',
    name: 'group-customer',
    component: () => import('@/views/pages/account-management/customers/group/GroupCustomer.vue'),
    meta: {
      pageTitle: 'Corporate/Group Customer',
      hasPermission: ['MODIFY_GROUP_CUSTOMER', 'CREATE_GROUP_CUSTOMER'],
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Corporate/Group Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/customer-relink',
    name: 'customer-relink',
    component: () => import('@/views/pages/account-management/customers/CustomerRelink.vue'),
    meta: {
      pageTitle: 'Customer Relink',
      hasPermission: 'RELINK_CUSTOMER',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Customer Relink',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/add-liens',
    name: 'lien',
    component: () => import('@/views/pages/account-management/customer-account/lien/Lien.vue'),
    meta: {
      pageTitle: 'Liens',
      hasPermission: 'CREATE_LIEN',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Liens',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/liens',
    name: 'liens',
    component: () => import('@/views/pages/account-management/customer-account/lien/index.vue'),
    meta: {
      pageTitle: 'Liens',
      hasPermission: 'VIEW_LIEN',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Liens',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/penalty',
    name: 'penalty',
    component: () => import('@/views/pages/account-management/Penalty.vue'),
    meta: {
      pageTitle: 'Penalty',
      hasPermission: 'VIEW_PENALTY',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Penalty',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/account-category',
    name: 'account-category',
    component: () => import('@/views/pages/account-management/AccountCategory.vue'),
    meta: {
      pageTitle: 'Account Category',
      hasPermission: 'VIEW_ACCOUNT_CATEGORY',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Account Category',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/interest-management',
    name: 'interest-management',
    component: () => import('@/views/pages/account-management/InterestManagement.vue'),
    meta: {
      pageTitle: 'Interest',
      hasPermission: 'VIEW_INTEREST',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Interests',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/profit-management',
    name: 'profit-management',
    component: () => import('@/views/pages/account-management/ProfitManagement.vue'),
    meta: {
      pageTitle: 'Profits',
      hasPermission: 'VIEW_PROFIT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Profits',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fee-management',
    name: 'fee-management',
    component: () => import('@/views/pages/account-management/GeneralLedger.vue'),
    meta: {
      pageTitle: 'Fees',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Fees',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/account-officer',
    name: 'account-officer',
    component: () => import('@/views/pages/account-management/account-officer/AccountOfficer.vue'),
    meta: {
      pageTitle: 'Account Officer',
      hasPermission: 'VIEW_ACCOUNT_OFFICER',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Account Officer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/account-officer-reassign',
    name: 'account-officer-reassign',
    component: () => import('@/views/pages/account-management/account-officer/Reassign.vue'),
    meta: {
      pageTitle: 'Re-assign Account Officer',
      hasPermission: 'ACCOUNT_OFFICER_REASSIGNMENT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Re-assign Account Officer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fixed-deposit-list',
    name: 'fixed-deposit-list',
    component: () => import('@/views/pages/account-management/customer-account/fixed-deposit/Index.vue'),
    meta: {
      pageTitle: 'Fixed Deposit',
      hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Fixed Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fixed-deposit/:type/:id?',
    name: 'fixed-deposit',
    component: () => import('@/views/pages/account-management/customer-account/fixed-deposit/FixedDeposit.vue'),
    meta: {
      pageTitle: 'Fixed Deposit',
      hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Fixed Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fixed-deposit-list-nib',
    name: 'fixed-deposit-list-nib',
    component: () => import('@/views/pages/account-management/customer-account/fixed-deposit-nib/Index.vue'),
    meta: {
      pageTitle: 'Fixed Deposit',
      hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT_NIB',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Fixed Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fixed-deposit-nib/:type/:id?',
    name: 'fixed-deposit-nib',
    component: () => import('@/views/pages/account-management/customer-account/fixed-deposit-nib/FixedDeposit.vue'),
    meta: {
      pageTitle: 'Fixed Deposit',
      hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT_NIB',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Accounts',
        },
        {
          text: 'Fixed Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/placement',
    name: 'placement',
    component: () => import('@/views/pages/account-management/Placement.vue'),
    meta: {
      pageTitle: 'Placement',
      hasPermission: 'VIEW_PLACEMENT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Placement',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/general-ledger',
    name: 'general-ledger',
    component: () => import('@/views/pages/account-management/GeneralLedger.vue'),
    meta: {
      pageTitle: 'General Ledgers',
      hasPermission: 'VIEW_GENERAL_LEDGER',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'General Ledgers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-fee',
    name: 'loan-fee',
    component: () => import('@/views/pages/account-management/fees/LoanFee.vue'),
    meta: {
      pageTitle: 'Loan Fee',
      hasPermission: 'VIEW_LOAN_FEE',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Fee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/cam-fee',
    name: 'cam-fee',
    component: () => import('@/views/pages/account-management/fees/CAMFee.vue'),
    meta: {
      pageTitle: 'CAM Fee',
      hasPermission: 'VIEW_COT_FEE',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'CAM Fee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/overdraft-fee',
    name: 'overdraft-fee',
    component: () => import('@/views/pages/account-management/fees/OverdraftFee.vue'),
    meta: {
      pageTitle: 'Overdraft Fee',
      hasPermission: 'VIEW_OVERDRAFT_FEE',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Overdraft Fee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan/:type/:id?',
    name: 'loan',
    component: () => import('@/views/pages/account-management/customer-account/loan/Loan.vue'),
    meta: {
      pageTitle: 'Loan Account',
      hasPermission: ['VIEW_LOAN_ACCOUNT', 'MODIFY_LOAN_ACCOUNT', 'CREATE_LOAN_ACCOUNT'],
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-list',
    name: 'loan-list',
    component: () => import('@/views/pages/account-management/customer-account/loan/Index.vue'),
    meta: {
      pageTitle: 'Loan Account',
      hasPermission: 'VIEW_LOAN_ACCOUNT',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-nib/:type/:id?',
    name: 'loan-nib',
    component: () => import('@/views/pages/account-management/customer-account/loanNIB/Loan.vue'),
    meta: {
      pageTitle: 'Loan Account',
      hasPermission: ['VIEW_LOAN_ACCOUNT_NIB', 'MODIFY_LOAN_ACCOUNT_NIB', 'CREATE_LOAN_ACCOUNT_NIB'],
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/loan-list-nib',
    name: 'loan-list-nib',
    component: () => import('@/views/pages/account-management/customer-account/loanNIB/Index.vue'),
    meta: {
      pageTitle: 'Loan Account',
      hasPermission: 'VIEW_LOAN_ACCOUNT_NIB',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/fixed-asset-register',
    name: 'fixed-asset-register',
    component: () => import('@/views/pages/account-management/FixedAssetsRegister.vue'),
    meta: {
      pageTitle: 'Fixed Assets Register',
      hasPermission: 'VIEW_FIXED_ASSET',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Fixed Assets Register',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/prepayment-amortization',
    name: 'prepayment-amortization',
    component: () => import('@/views/pages/account-management/PrepaymentAmortization.vue'),
    meta: {
      pageTitle: 'Prepayment Amortization',
      hasPermission: 'VIEW_PREPAYMENT_AMORTIZATION',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Prepayment Amortization',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account-management/abridged-loan-account',
    name: 'abridged-loan-account',
    component: () => import('@/views/pages/account-management/customer-account/AbridgedLoanAccount.vue'),
    meta: {
      pageTitle: 'Abridged Loan Account',
      hasPermission: 'VIEW_ABRIDGED_LOAN',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Abridged Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/standing-order',
    name: 'standing-order',
    component: () => import('@/views/pages/account-management/StandingOrder.vue'),
    meta: {
      pageTitle: 'Standing Order',
      hasPermission: 'VIEW_STANDING_ORDERS',
      breadcrumb: [
        {
          text: 'Accounts',
        },
        {
          text: 'Standing Order',
          active: true,
        },
      ],
    },
  },
]
